import { isMobile, lockBody, unlockBody } from '../functions'
document.addEventListener('DOMContentLoaded', function (e) {
  const navbar = e.target.querySelector('.js-navbar')
  if (navbar) {
    if (window.innerWidth >= 768) {
      const menuItems = navbar.querySelectorAll('.menu-item a')
      for (const element of menuItems) {
        if (element.href === vnObject.contactPage) {
          element.innerHTML += '<i class="vn-icons-arrow-right"></i>'
        }
      }
    }
    const jsMenuToggle = navbar.querySelector('.js-menu-toggle')
    if (jsMenuToggle) {
      jsMenuToggle.addEventListener('click', function () {
        navbar.classList.toggle('active')
        const condition = navbar.classList.contains('active')
        const oldIcon = condition ? 'menu' : 'close'
        const icon = !condition ? 'menu' : 'close'
        jsMenuToggle
          .querySelector('i')
          .classList.replace('vn-icons-' + oldIcon, 'vn-icons-' + icon)
        condition ? lockBody() : unlockBody()
      })
    }
    window.addEventListener('scroll', function () {
      const val = isMobile() ? 750 : 150
      if (this.scrollY > this.innerHeight - val) {
        navbar.classList.add('scrolling')
      } else {
        navbar.classList.remove('scrolling')
      }
    })
  }
})
